<div [style.min-height.px]="minHeight" class="flex flex-col justify-between">
	<div class="flex flex-col gap-[24px] grow">
	<div>
		<ng-container *ngTemplateOutlet="header"></ng-container>
	</div>
	<div>
		<ng-container *ngTemplateOutlet="body"></ng-container>
	</div>
	</div>
	<div>
		<ng-container *ngTemplateOutlet="footer"></ng-container>
	</div>
</div>


<ng-template #header>
	<div class="flex flex-col gap-[8px]">
		<div class="text-[#1A1A1A] leading-[24.48px] text-[18px] font-bold">
			{{title}}
		</div>
		<div class="text-[#4D4D4D] leading-[19.6px] text-[14px] font-normal">
			{{description}}
		</div>
	</div>
</ng-template>

<ng-template #body>
	<div class="flex flex-col gap-[24px] justify-center">
		<div class="grow">
			<app-kamona-otp idV2="otp" [version]="KamonaOtpVersion.version_2"
							(emitInput)="setOtp($event)" ></app-kamona-otp>
		</div>
		<div>
			<div class="bg-[#F2F7FE] items-center justify-between rounded-[8px] p-[12px] flex gap-[9px]">
				<div class="flex items-center gap-[9px]">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" fill="#0361F0"/>
					</svg>
					<div class="text-[12px] text-black leading-[17.76px] font-normal">
						Didn’t get the code?
					</div>
				</div>
				<button (click)="handleOtpAction()" class="text-[#0361F0] justify-end cursor-pointer leading-[17.36px] text-[14px] font-medium disabled:text-[#999999]" [disabled]="showResendButtonCountDown">
					Resend
					<ng-container *ngIf="showResendButtonCountDown">
						<span class="inline-flex">
							(<span>
								{{formatTime(resendButtonCountDown?.minute)}}
							</span>
							<span>:</span>
							<span>
								{{formatTime(resendButtonCountDown?.second)}}
							</span>)
						</span>
					</ng-container>
				</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #footer>
	<div class="mt-[24px]">
		<div [ngClass]="{'max-w-[335px] ml-auto':!hideBackBtn}"
			 class="flex items-center justify-end gap-[16px]">
			<div *ngIf="!hideBackBtn" (click)="goBack()"
				 [ngClass]="{'gray-out': submitting}"
				 class="back-btn grow text-center">Back</div>
			<div class="kamona-desktop-button-wrapper-v2 grow">
				<app-kamona-custom-button
					(submitForm)="submit()"
					[isBlock]="true"
					[isDisabled]="!(otp?.length === noOfPin)"
					[isSubmitting]="submitting"
					[type]="'primary'"
					[text]="btnText">
				</app-kamona-custom-button>
			</div>
		</div>
	</div>
</ng-template>
